module.exports = __webpack_public_path__ + "images/53ebc44d84045c504b036e736281e061-illu_panelA.svg";